import React from 'react';
import './LoadingSpinner.css';

export interface LoadingSpinnerProps {
  size?: 'small' | 'medium' | 'large';
  className?: string;
  text?: string;
  fullScreen?: boolean;
}

/**
 * Reusable LoadingSpinner component
 */
const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  size = 'small',
  className = '',
  text,
  fullScreen = false
}) => {
  const sizeClass = `common-spinner--${size}`;
  const spinnerClassName = className 
    ? `common-spinner ${sizeClass} ${className}`.trim()
    : `common-spinner ${sizeClass}`.trim();

  const content = (
    <div className="common-spinner-container">
      <div className={spinnerClassName}></div>
      {text && <p className="common-spinner-text">{text}</p>}
    </div>
  );

  if (fullScreen) {
    return (
      <div className="common-spinner-fullscreen">
        {content}
      </div>
    );
  }

  return content;
};

export default LoadingSpinner;

